import { env } from '@/lib/utils/env';

/** Host-app CDN host list for afrodita `OptimizedImage` / `buildSrcSet`. */
export function resolveCdnHosts(): string {
  return env.CDN_HOSTS?.trim() ?? '';
}
